import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { AppDispatch, store } from '../redux/store';
import { ReduxController } from '../redux/utils/ReduxController';
import tpcQuestionApi from '../redux/api/questionApiSlice';

@customElement('tpc-corrector-question-view-feedback')
export class TPCQuestionViewFeedback extends LitElement {
    createRenderRoot() {
        return this;
    }
    dispatch = store.dispatch as AppDispatch;
    rxController = new ReduxController(this);
    get store() {
        return this.rxController.state;
    }

    @property({ type: String })
    questionUuid: string | undefined;

    @state()
    private feedbackType: 'positive' | 'negative' | null = null;

    @state()
    loading = false;

    @state()
    inputFeedback = '';

    toggleFeedback(type: 'positive' | 'negative') {
        this.feedbackType = type;
        this.emitFeedback();
    }

    emitFeedback() {
        this.dispatchEvent(
            new CustomEvent('feedbackActive', {
                detail: {
                    active: this.feedbackType !== null,
                },
            })
        );
    }

    closeFeedback() {
        this.feedbackType = null;
        this.inputFeedback = '';
        this.emitFeedback();
    }

    async sendFeedback() {
        if (this.loading || this.feedbackType === null || !this.questionUuid) {
            return;
        }
        this.loading = true;
        await this.dispatch(
            tpcQuestionApi.endpoints.sendFeedback.initiate({
                feedback: this.inputFeedback,
                type: this.feedbackType,
                tpc_uuid: this.questionUuid,
                isTutor: this.store.appState.isTutor,
            })
        );
        this.loading = false;
        this.closeFeedback();
    }

    render() {
        return html`
            <div
                class="tpc-corrector-question-view-content-actions-feedback ${this.feedbackType
                    ? 'active'
                    : ''}"
            >
                <div class="tpc-corrector-question-view-content-actions-feedback-header">
                    A resposta foi útil?
                    <button
                        class="tpc-corrector-question-view-content-actions-feedback-button ${this
                            .feedbackType === 'positive'
                            ? 'active'
                            : ''}"
                        @click=${() => this.toggleFeedback('positive')}
                    >
                        <span class="icon icon-041-thumbs"></span>
                    </button>
                    <button
                        class="tpc-corrector-question-view-content-actions-feedback-button ${this
                            .feedbackType === 'negative'
                            ? 'active'
                            : ''}"
                        @click=${() => this.toggleFeedback('negative')}
                    >
                        <span class="icon icon-down icon-041-thumbs"></span>
                    </button>
                    <button class="close-button" @click=${this.closeFeedback}>
                        <span class="icon icon-027-outline-close"></span>
                    </button>
                </div>
                <div
                    class="tpc-corrector-question-view-content-actions-feedback-content-shadow"
                    @click=${this.closeFeedback}
                ></div>
                <div class="tpc-corrector-question-view-content-actions-feedback-content">
                    <div class="tpc-corrector-question-view-content-actions-feedback-content-title">
                        <span
                            class="icon icon-041-thumbs ${this.feedbackType === 'positive'
                                ? 'icon-up'
                                : 'icon-down'}"
                        ></span>
                        Obrigado. Como podemos
                        melhorar${this.feedbackType === 'positive' ? ' mais' : ''}?
                    </div>

                    <div
                        class="tpc-corrector-question-view-content-actions-feedback-content-textarea-container"
                    >
                        <textarea
                            class="tpc-corrector-question-view-content-actions-feedback-content-textarea"
                            placeholder="Escreva aqui para que possamos melhorar"
                            @input=${(event: Event) =>
                                (this.inputFeedback = (event.target as HTMLTextAreaElement).value)}
                            .value=${this.inputFeedback}
                            maxlength="500"
                        ></textarea>
                        <button
                            class="ds-button ds-button--primary submit-button"
                            @click=${this.sendFeedback}
                            .disabled=${this.loading}
                        >
                            ${this.loading ? 'Enviando...' : 'Enviar'}
                        </button>
                    </div>
                </div>
            </div>
        `;
    }
}
